import request from "../plugins/axios";

/**
 * 课程
 */
//  课程列表
export function groupManagerList(params) {
	return request({
		url: '/scrm/groupManagerList',
		method: 'GET',
		params
	})
}
export function tenantServicePackList(params) {
	return request({
		url: '/scrm/TenantServicePackList',
		method: 'GET',
		params
	})
}
export function tenantServicePackPay(data) {
	return request({
		url: '/scrm/TenantServicePackPay',
		method: 'POST',
		data
	})
}
export function groupManagerDetails(params) {
	return request({
		url: '/scrm/GroupManagerDetails',
		method: 'GET',
		params
	})
}
export function groupManagerTrainList(params) {
	return request({
		url: '/scrm/GroupManagerTrainList',
		method: 'GET',
		params
	})
}
export function groupManagerTrainCourseList(params) {
	return request({
		url: '/scrm/GroupManagerTrainCourseList',
		method: 'GET',
		params
	})
}

export function tenantVideoDataStatisticsLogic(params) {
	return request({
		url: '/scrm/TenantVideoDataStatisticsLogic',
		method: 'GET',
		params
	})
}

export function employeeStatus(data) {
	return request({
		url: '/scrm/employeeStatus',
		method: 'POST',
		data
	})
}
export function auditOrderList(params) {
	return request({
		url: process.env.VUE_APP_API_BASE_URL+'/mall/order/qgOrderList',
		method: 'GET',
		params
	})
}

export function auditOrder(params){
	return request({
		url: process.env.VUE_APP_API_BASE_URL+'/mall/order/review',
		method: 'GET',
		params
	})
}

export function groupManagerManualForbiddenDomain(data){
	return request({
		url: '/scrm/groupManagerManualForbiddenDomain',
		method: 'POST',
		data
	})
}